export const LT_ACTIVITY = 'activity';
export const LT_MENU = 'menu';
